var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRestore = function SvgRestore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.016h1.5v4.219l3.516 2.109-.75 1.219L12 12.985V8.016zM12.984 3c4.969 0 9 4.031 9 9s-4.031 9-9 9a8.85 8.85 0 0 1-6.328-2.625l1.406-1.453c1.266 1.266 3 2.063 4.922 2.063 3.891 0 7.031-3.094 7.031-6.984s-3.141-6.984-7.031-6.984S6 8.111 6 12.001h3l-4.031 4.031-.094-.141L.984 12h3c0-4.969 4.031-9 9-9z"
  })));
};
export default SvgRestore;